<template>
    <div class="quiz">
        <h1>QUIZ</h1>

        <div v-if="started===false && isAnswered==false">
            <template v-if="language==='de'">
                <button class="answer" @click="started=new Date()">Frage stellen</button>
            </template>
            <template v-if="language==='pl'">
                <button class="answer" @click="started=new Date()">
                    zadaj pytanie
                </button>

            </template>
        </div>
        <div v-if="started===false &&  isAnswered==true">
            <template v-if="language==='de'">
                Diese Quizfrage wurde schon beantwortet.
            </template>
            <template v-if="language==='pl'">
                Odpowiedzi na to pytanie już udzielono.
            </template>
        </div>
        <div v-if="started!==false">
            <template v-if="language==='de'">
                <h2 v-if="hideQuestion===false"> {{ question.de.Frage }} </h2>

                <button v-if="hideQuestion===false && b.length>0"
                        v-for="b,index in question.de.Antworten"
                        class="answer"
                        :class="{highlight:index == answerednumber}"
                        @click="answered(index)">
                    <font-awesome-icon icon="check" class="haken" size="lg"
                                       v-if="showRightAnswer===true && index ==  question.Antwort"/>
                    <font-awesome-icon icon="times" class="kreuz" size="lg"
                                       v-if="showRightAnswer===true && index == answered && index !=  question.Antwort"/>
                    {{b}}
                </button>
            </template>

            <template v-if="language==='pl'">
                <h2 v-if="hideQuestion===false"> {{ question.pl.Frage }} </h2>

                <button v-if="hideQuestion===false && b.length>0"
                        v-for="b,index in question.pl.Antworten"
                        class="answer"
                        :class="{highlight:index == answerednumber}"
                        @click="answered(index)">
                    <font-awesome-icon icon="check" class="haken" size="lg"
                                       v-if="showRightAnswer===true && index ==  question.Antwort"/>
                    <font-awesome-icon icon="times" class="kreuz" size="lg"
                                       v-if="showRightAnswer===true && index == answered && index !=  question.Antwort"/>
                    {{b}}
                </button>
            </template>

            <span class="status">{{ status }}</span>
        </div>
    </div>
</template>

<script type="text/babel">

    export default {
        name: 'Quiz',
        props: {
            questions: Array,
            waypointid: {}
        },
        data() {
            return {
                status: '',
                question: {},
                started: false,
                hideQuestion: false,
                showRightAnswer: false,
                answerednumber: Object
            }
        },
        computed: {
            language: function () {
                return this.$root.$i18n.locale;
            },
            isAnswered: function () {
                let foundIndex = this.$root.solvedQuizes.findIndex(x => x.id == this.waypointid);
                return foundIndex >= 0;
            }
        },
        mounted() {
            this.showRightAnswer = false;
            this.question = this.questions[Math.floor(Math.random() * this.questions.length)];
            //console.log(this.question);
        },
        methods: {
            answered: function (index) {
                //console.log('Pressed ' + index);

                if (this.answerednumber > 0) return;

                this.answerednumber = index;

                let foundIndex = this.$root.solvedQuizes.findIndex(x => x.id == this.waypointid);


                if (this.answerednumber == parseInt(this.question.Antwort)) {
                    // alert('RICHTIG!');
                    this.status = 'Richtig!';


                    let wpitem = {
                        id: this.waypointid,
                        answerRight: true,
                        startDate: this.started,
                        endDate: new Date()
                    }

                    if (foundIndex >= 0) {
                        this.$set(this.$root.solvedQuizes, foundIndex, wpitem)

                        //this.$root.solvedQuizes[foundIndex] = wpitem;
                    } else {
                        this.$root.solvedQuizes.push(wpitem);
                    }
                } else {
                    //alert('Leider falsch');
                    this.status = 'Leider falsch!';
                    let wpitem = {
                        id: this.waypointid,
                        answerRight: false,
                        startDate: this.started,
                        endDate: new Date()
                    }

                    if (foundIndex >= 0) {
                        this.$set(this.$root.solvedQuizes, foundIndex, wpitem)

                        //qsolved[foundIndex] = wpitem;
                    } else {
                        this.$root.solvedQuizes.push(wpitem);
                    }

                }


                // this.hideQuestion = true;
                this.showRightAnswer = true;
            }
        }
    }
</script>

<style scoped lang="scss">
    .haken {
        color: green;
    }

    .kreuz {
        color: red;
    }

    h1 {
        text-align: center;
        font-size: 22px;
        line-height: 24px;
        margin-bottom: 20px;
    }

    h2 {
        font-weight: normal;
        font-size: 18px;
        line-height: 20px;
        margin-bottom: 20px;
    }

    button.answer {
        padding: 6px;
        border-radius: 3px;
        margin-bottom: 15px;
        width: 100%;
        box-sizing: border-box;
        display: inline-block;
        border: none;
        background-color: #fff;
        color: #444444;
        font-size: 18px;
        line-height: 20px;
        cursor: pointer;
    }

    button.highlight {
        background-color: yellow;
    }

    .status {
        font-size: 18px;
        line-height: 20px;
    }
</style>
